$(function(){

    $('.select .form-control').on('focus', function () {
        $(this).closest('.select').addClass('active');
    });

    $('.select .form-control').on('focusout', function () {
        $(this).closest('.select').removeClass('active');
    });
})